import MenuCartSeat from './MenuCartSeat';

export default MenuCartSeat;
